/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useCloudApolloClient from "../Utils/useCloudApolloClient";
import CloudApolloClient from "./CloudApolloClient";

export default class CloudApolloClientProvider {
    private static _client: CloudApolloClient | null = null;

    public get client(): CloudApolloClient {
        if (CloudApolloClientProvider._client === null) {
            CloudApolloClientProvider._client = useCloudApolloClient();
        }

        return CloudApolloClientProvider._client;
    }
}
